import { module as modujs } from "modujs";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends modujs {
	constructor(m) {
		super(m);

		this.gsapInstances = [];

		this.events = {
			click: {
				link: "openSubmenu",
				back: "back",
			},
		};
	}

	init() {
		this.$html = document.querySelector("html");
		this.$submenus = this.$("submenu");

		gsap.set(this.$submenus, { yPercent: -100 });

		this._keydownHandler = this.keydown.bind(this);
		document.addEventListener("keydown", this._keydownHandler);
	}

	keydown(event) {
		if (event.keyCode == 27) {
			this.close();
		}
	}

	open() {
		gsap.to(this.el, {
			yPercent: 0,
			duration: 0.8,
			ease: "power1.out",
		});

		this.$html.classList.add("has-menu-open");
	}

	close() {
		gsap.to(this.el, {
			yPercent: -100,
			duration: 0.8,
			ease: "power1.out",
		});

		this.$html.classList.remove("has-menu-open");

		window.dispatchEvent(new CustomEvent("menu:close"));

		this.closeSubmenus();
	}

	back() {
		this.closeSubmenus(); // ← juste refermer le submenu, c'est tout
	}

	openSubmenu(e) {
		const $currentSubmenu = Array.from(this.$submenus).filter((el) => e.currentTarget.closest('[data-menu-mobile="item"]').contains(el))[0];

		if (!$currentSubmenu) return;

		if (this.$activeSubmenu != $currentSubmenu) {
			this.closeSubmenus();
			this.$activeSubmenu = $currentSubmenu;

			gsap.to(this.$activeSubmenu, {
				yPercent: 0, // ← était xPercent
				duration: 0.5,
				ease: "power2.out",
			});
		} else {
			this.closeSubmenus();
		}
	}

	closeSubmenus() {
		gsap.to(this.$submenus, {
			yPercent: -100, // ← était xPercent: 100
			duration: 0.5,
			ease: "power2.out",
		});

		this.$activeSubmenu = undefined;
	}

	destroy() {
		this.gsapInstances.forEach((instance) => {
			if (instance) {
				if (instance.scrollTrigger) {
					instance.scrollTrigger.kill();
				}
				instance.kill();
			}
		});
		this.gsapInstances = [];
	}
}
